var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("editar-usuario"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { info: "" } }, [_vm._v("group")]),
          _vm._v("Usuarios")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      !_vm.filterShow
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator", icon: "" },
                              on: {
                                click: function(v) {
                                  _vm.filterShow = true
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("filter_list")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Filtros")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _vm.filterShow
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-refresh",
                              attrs: { slot: "activator", icon: "" },
                              on: {
                                click: function(v) {
                                  _vm.filterShow = false
                                }
                              },
                              slot: "activator"
                            },
                            [_c("v-icon", [_vm._v("filter_list")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [_vm._v("Ocultar")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.listarUsuarios()
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.filterShow
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "search",
                              label: "Usuario",
                              "single-line": "",
                              "hide-details": ""
                            },
                            on: { input: _vm.filterUsuario }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "search",
                              label: "Nombre completo",
                              "single-line": "",
                              "hide-details": ""
                            },
                            on: { input: _vm.filterNombreCompleto }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              "append-icon": "search",
                              label: "Correo",
                              "single-line": "",
                              "hide-details": ""
                            },
                            on: { input: _vm.filterCorreo }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_usuarios,
                  "item-key": "id",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "no-data-text": "Sin datos"
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nombre_usuario))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.nombre_completo) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.correo))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "ul",
                            _vm._l(items.item.roles, function(rol) {
                              return _c("li", { key: rol.id }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(rol.descripcion) +
                                    "\n              "
                                )
                              ])
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { attrs: { title: "Activar/Desactivar usuario" } },
                          [
                            _c("v-switch", {
                              attrs: {
                                value: "",
                                "input-value":
                                  items.item.id_estado === "1" ? true : false
                              },
                              on: {
                                change: function($event) {
                                  return _vm.cambiarEstado(items.item)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            items.item.id_estado === "1"
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      label: "",
                                      color: "success",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(items.item.estado.descripcion) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            items.item.id_estado === "2"
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      label: "",
                                      color: "error",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(items.item.estado.descripcion) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { slot: "activator", icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.editarUsuario(items.item)
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("edit")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v("Editar registro")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c27eb20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c27eb20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/usuario_sistema/Usuario.vue
// module id = null
// module chunks = 